import { useState, useEffect } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { TemplateState } from '../types';

export function useTemplateState(templateId: string, isPremium: boolean, hasPicloPlay: boolean, refreshTrigger: number = 0) {
  const [state, setState] = useState<TemplateState>('UNPLAYED');
  const [localSnapshotUri, setLocalSnapshotUri] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function checkState() {
      try {
        setLoading(true);
        
        // 1. Check for completion snapshot
        const snapshotKey = `piclo_snapshot_${templateId}`;
        const savedSnapshot = await AsyncStorage.getItem(snapshotKey);
        
        if (savedSnapshot) {
          setState('COMPLETED');
          setLocalSnapshotUri(savedSnapshot);
        } else if (isPremium && !hasPicloPlay) {
          // 2. Check for premium lock
          setState('LOCKED');
        } else {
          // 3. Default to unplayed
          setState('UNPLAYED');
        }
      } catch (error) {
        console.error('Error checking template state:', error);
      } finally {
        setLoading(false);
      }
    }

    checkState();
  }, [templateId, isPremium, hasPicloPlay, refreshTrigger]);

  return { state, localSnapshotUri, loading };
}
